import Access from './access.vue'

export default Access



// WEBPACK FOOTER //
// ./src/views/user/access/index.js